import DashboardPage from "./dashboard-pages/DashboardPage";
import UserCrudPage from "./dashboard-pages/UserCrudPage";
import RecordsCrudPage from "./dashboard-pages/RecordsCrudPage";

interface Route {
  path: string;
  exact?: boolean | undefined;
  name: string;
  component?: any;
  permissionName?: string;
}

interface RouteMap {
  [index: string]: Route;
}

const routes: RouteMap = {
  dashboard: {
    path: "/dashboard/",
    name: "Inicio",
    exact: true,
    component: DashboardPage,
  },
  users: {
    path: "/users/",
    name: "Usuarios",
    exact: true,
    component: UserCrudPage,
  },
  records: {
    path: "/codes/",
    name: "QR generados",
    exact: true,
    component: RecordsCrudPage,
  },
};

export const getRoutePath = (key: string) => {
  return routes[key].path;
};
export const getRouteName = (key: string) => {
  return routes[key].name;
};

export default routes;
